import React , {Component} from 'react';
import secondaryApp from '../BD/secondaryApp';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import firebase from 'firebase';
import axios from 'axios';

import store from '../../store';

const qrCode = require('qrcode-npm')

const text="-L6TFyzo5H6lBpdIisHA";
const qr = qrCode.qrcode(4, 'M');


const customStyles = {
  content : {
    top                   : '60%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'
	
  }
};


const database=firebase.database();

class ModalInvitadosEmpresas extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			isActive:false,
			isActiveInformacion:false
			
		}
		
		
		this.toggleModal=this.toggleModal.bind(this);
		this.handleOnSubmit=this.handleOnSubmit.bind(this);
		this.toggleModalInformacion=this.toggleModalInformacion.bind(this);
		
		this.invitadosRef=database.ref().child('Invitados');
		
		
	}
	
	
	componentDidMount(){
		
		
	}
	
	componentWillMount(){
		
		
	}
	
	toggleModal(){
		
		this.setState({			
			isActive:!this.state.isActive			
		})
		
	}
	
	toggleModalInformacion(){
		
		this.setState({
			isActiveInformacion:!this.state.isActiveInformacion
					
		})
		
	}
	
	
	handleOnSubmit(event){
		
		event.preventDefault();		
		
		const correo_contacto=this.contacto.value;
		
		
		
		let nombre=this.nombre.value;
		let apellido=this.apellido.value;
		let dui=this.dui.value;
		let pasaporte=this.pasaporte.value;
		let fecha_inicio=this.fecha_inicio.value;
		let fecha_final=this.fecha_final.value;
		let hora_inicio=this.hora_inicio.value;
		let hora_final=this.hora_final.value;
		
		
		
		let key=this.invitadosRef.push({
			
			nombre:nombre,
			apellido:apellido,
			pasaporte:pasaporte,
			dui:dui,
			nombre_empresa:store.getState().nombre_empresa,
			codigo_empresa:firebase.auth().currentUser.uid,
			fecha_inicio:fecha_inicio,
			fecha_final:fecha_final,
			hora_inicio:hora_inicio,
			hora_final:hora_final,
			estado:'subir'
			
		})
		
		
		let subkey=key.getKey().substring(1,7);
		
		let nombre_split=nombre.split(' ');
		let mail=(subkey+'.'+nombre_split[0].toLowerCase()+'@mail.com').toLowerCase();
		let password=nombre.substring(0,1).toLowerCase()+apellido.substring(0,1).toLowerCase()+parseInt(Math.random()*(9999,1000)+1000);
		
		
		
		secondaryApp.auth().createUserWithEmailAndPassword(mail,password)
		.then(user => {
			
			
				
				this.invitadosRef.child(key.getKey()).update({
					
					correo:mail,
					contrasena:password
			
				});
				
				
				qr.addData(key.getKey());
				qr.make();
				
				
				let escapedStr=qr.createImgTag(4);
		
				let arreglo=escapedStr.split('"');

		
				const form=  axios.post('/contact',{
					mail:correo_contacto,
					imagen:arreglo[1],
					usuario:mail,
					clave:password,
					nombre:nombre+' '+apellido,
					empresa:store.getState().nombre_empresa,
					fecha_inicio:fecha_inicio,
					fecha_fin:fecha_final,
					hora_inicio:hora_inicio,
					hora_fin:hora_final					
			
				});
				
				this.setState({			
					nombre:nombre,
					apellido:apellido,
					correo:mail,
					contrasena:password,
					fecha_inicio:fecha_inicio,
					fecha_final:fecha_final,
					hora_inicio:hora_inicio,
					hora_final:hora_final
				})
			
			
				Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
				
				this.toggleModal();
				this.toggleModalInformacion();
		
		})
		.catch(error =>{
			
			
				//Si no se logro crear la cuenta por error se elimina el registro del invitado
				this.invitadosRef.child(key.getKey()).remove();
			
				let msj='Error al ingresar usuario';
			
				if(error.code==='auth/email-already-in-use'){	
					msj='Ya existe una cuenta con la dirección de correo electrónico especificada.';
				}
				else if(error.code==='auth/invalid-email'){					
					msj='Dirección de correo electronico no valida.';					
				}
				
				else if(error.code==='auth/weak-password'){
					
					msj='La contraseña ingresada no es demasiado fuerte.';
						
				}

				Alert.error(msj, {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
				});
			
				
		});
		
	}
	
	
	
	render(){
		
		
		return(
		
			<div className="modal_invitados_empresas">
					<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
			
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >				

						<form method="POST" action="" onSubmit={this.handleOnSubmit}>
					
							<center><h3>Ingresar invitados</h3></center>
							<hr/>
							
						
							<div className="form-group">
								<label>Nombre</label>
								<input type="text" className="form-control" placeholder="Nombre" required
								ref={input=>{this.nombre=input;}}
								/>
							</div>
							<div className="form-group">
								<label>Apellido</label>
								<input type="text" className="form-control" placeholder="Apellido" required
								ref={input=>{this.apellido=input}}
								/>
							</div>
							<div className="form-group">
								<label>Dui</label>
								<input type="text" className="form-control" placeholder="Dui" required
								ref={input=>{this.dui=input}}
								/>
							</div>
							<div className="form-group">
									<label htmlFor="email">Correo de contacto</label>
									<input type="email" name="mail" className="form-control" placeholder="Correo de contacto"
									required autoComplete="off"
									ref={input=>{this.contacto=input}}
									
									/>
							</div>
							<div className="form-group">
								<label>Pasaporte</label>
								<input type="text" className="form-control" placeholder="Pasaporte" required
								ref={input=>{this.pasaporte=input}}
								/>
							</div>
							<div className="form-group">
								<label>Fecha Inicio</label>
								<input type="date" required autoComple="off"
								ref={input=>{this.fecha_inicio=input}}
								className="form-control"
								/>
							</div>
							<div className="form-group">
								<label>Fecha  Final</label>
								<input type="date" required autoComple="off"
								ref={input=>{this.fecha_final=input}}
								className="form-control"								
								/>
							</div>
							<div className="form-group">
								<label>Hora inicio</label>
								<input type="time" required autoComple="off"
								ref={input=>{this.hora_inicio=input}}
								className="form-control"
								/>
							</div>
							<div className="form-group">
								<label>Hora Final</label>
								<input type="time" required autoComple="off"
								ref={input=>{this.hora_final=input}}
								className="form-control"
								/>
							</div>
						
					
							<button type="submit" className="btn btn-primary buttons" >Guardar</button>
						</form>
							<button type="button" className="btn btn-default buttons  btnmargin" onClick={this.toggleModal}>Cerrar</button>
					
					</Modal>
					
					<Modal isOpen={this.state.isActiveInformacion} onRequestClose={this.toggleModalInformacion} style={customStyles}>
						<fieldset>
						<legend>Información del invitado</legend>						
						<hr/>
						<label>Nombre del invitado</label>
						<p>{this.state.nombre+' '+this.state.apellido}</p>
						<label>Invitado de la empresa</label>
						<p>{this.state.nombre_empresa}</p>
						<label>Fecha de inicio</label>
						<p>{this.state.fecha_inicio}</p>
						<label>Fecha fin</label>
						<p>{this.state.fecha_final}</p>
						<label>Hora inicio</label>
						<p>{this.state.hora_inicio}</p>
						<label>Hora fin</label>
						<p>{this.state.hora_final}</p>
						<label>Correo</label>
						<p>{this.state.correo}</p>
						<label>Contraseña</label>
						<p>{this.state.contrasena}</p>
						
						<hr/>
						<button type="button" className="btn btn-danger buttons" onClick={this.toggleModalInformacion} > Cerrar</button>
						</fieldset>
					</Modal>
					
			
			</div>
			
		
		
		);
		
		
	}
	
	
}

export default ModalInvitadosEmpresas;


// WEBPACK FOOTER //
// ./src/Components/Invitados/ModalInvitadosEmpresas.js